module.exports = __webpack_public_path__ + "static/media/distraction-bus.ad57d845.png";